import styled from 'styled-components';

import { HEADER_AND_FOOTER_HEIGHT } from '../PageWrapper/styled';

export const Wrapper = styled.div<{ isGhostMode?: boolean }>`
  padding: 0 ${({ theme }): string => theme.spacers!.spacer06};
  flex-basis: 100%;
  min-height: ${({ isGhostMode }): string => {
    const ghostModeHeight = isGhostMode ? 36 : 0;
    return `calc(100vh - ${HEADER_AND_FOOTER_HEIGHT + ghostModeHeight}px) `;
  }};
`;
